export default "__VITE_ASSET__D6siOkL8__"